import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function CTASection({
  eyebrow = "> ready.when_you_are",
  title = "Let's build the thing that actually ships.",
  subtitle = "Tell us what you're modernizing, building, or scaling. We'll reply with a pragmatic path forward, not a sales pitch.",
  ctaLabel = "Request a Demo",
  ctaTo = "/contact",
  secondaryLabel = "Talk to Founder",
  secondaryTo = "/founder",
}) {
  return (
    <section
      data-testid="cta-section"
      className="relative overflow-hidden bg-obsidian"
    >
      <div className="absolute inset-0 bg-grid opacity-40" />
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-neon-green/[0.04]" />

      <div className="relative max-w-5xl mx-auto px-5 lg:px-8 py-24 lg:py-32 text-center">
        <div className="chip text-neon-green">{eyebrow}</div>
        <h2 className="mt-4 font-display font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tighter leading-[0.95]">
          {title}
        </h2>
        <p className="mt-6 mx-auto max-w-2xl text-white/60 text-sm md:text-base leading-relaxed">
          {subtitle}
        </p>
        <div className="mt-10 flex flex-wrap gap-4 justify-center">
          <Link
            to={ctaTo}
            data-testid="cta-primary"
            className="group inline-flex items-center gap-2 bg-neon-green text-obsidian px-6 py-3.5 text-sm font-mono font-bold uppercase tracking-widest hover:shadow-[0_0_40px_rgba(0,255,65,0.6)] hover:-translate-y-0.5 transition-all"
          >
            {ctaLabel}
            <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </Link>
          <Link
            to={secondaryTo}
            data-testid="cta-secondary"
            className="inline-flex items-center gap-2 border border-white/20 text-white px-6 py-3.5 text-sm font-mono font-semibold uppercase tracking-widest hover:border-neon-cyan hover:text-neon-cyan transition-all"
          >
            {secondaryLabel}
          </Link>
        </div>
      </div>
    </section>
  );
}
